import {countryArr} from "@/assets/js/country";
import {nationArr} from "@/assets/js/nation";
import {languageArr} from "@/assets/js/language";
import {teacher_sign_info_view} from '@/api/training_teacher/api'
import { debug } from "util";
const HOST = process.env.VUE_APP_URL;


export default {
  data() {
    const gender = [
      {
        key: "男",
        val: "Male"
      },
      {
        key: "女",
        val: "Female"
      },
    ];
    return {
      gender,
      countryArr,
      nationArr,
      languageArr,
      stuInfo: {},
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      teacher_sign_info_view({})
        .then(({data}) => {

          if (Number(data.status) === 0) {
            // console.log(data);
            let {language_list, academic_data, experience_data, playing_data, studentSingnInfo,tea_level_data,coa_level_data,teacher_honor_experience} = data.result;
            // 护照头像，身份证正反面
            studentSingnInfo.profile_picture && (this.photo = HOST + studentSingnInfo.profile_picture);
            if (studentSingnInfo.family_name_spell && !studentSingnInfo.given_name_spell){
              this.$set(this.vitaForm,'family_name_spell',studentSingnInfo.family_name_spell);
              this.switch_pinyin=true;
            }
            if(studentSingnInfo.family_name_spell && studentSingnInfo.given_name_spell){
              this.spell_both=true;
            }
            if(studentSingnInfo.family_name_spell && !studentSingnInfo.given_name_spell){
              this.spell_family=true;
            }
            if(!studentSingnInfo.family_name_spell && !studentSingnInfo.given_name_spell){
              this.spell_none=true;
            }
            this.id_type=studentSingnInfo.id_type
            if (studentSingnInfo.info_status==='pass') this.not_allow_change=true
            studentSingnInfo.id_card_photo_front && (this.cardFront = HOST + studentSingnInfo.id_card_photo_front);
            studentSingnInfo.id_card_photo_verso && (this.cardBack = HOST + studentSingnInfo.id_card_photo_verso);
            // 外语
            language_list.length && this.$set(this.vitaForm, "language_row", language_list);
            //  其他荣誉和经历
            teacher_honor_experience.length && this.$set(this.vitaForm,'teacher_honor_experience',teacher_honor_experience)
            //  coa_level_data
            coa_level_data.length && this.$set(this.vitaForm,'coa_level_data',coa_level_data)
            // 公用临时数组
            let tempArr = [];
            // 教育经历
            let academic_qualification = [];
            if (academic_data.length) {
              academic_qualification = academic_data.map((item) => {
                if(item.academic_start_date && item.academic_end_date) {
                  tempArr = [new Date(item.academic_start_date), new Date(item.academic_end_date)];
                } else {
                  tempArr = [];
                }
                return {
                  ...item,
                  time: tempArr,
                };
              });
            }
            // 执教经历
            let coaching_Experience = [];
            if (experience_data.length) {
              coaching_Experience = experience_data.map((item) => {
                if(item.coach_start_date && item.coach_end_date) {
                  tempArr = [new Date(item.coach_start_date), new Date(item.coach_end_date)];
                } else {
                  tempArr = [];
                }
                return {
                  ...item,
                  time: tempArr,
                };
              });
            }
            // 运动经历
            let playing_experience = [];
            if (playing_data.length) {
              playing_experience = playing_data.map((item) => {
                if(item.play_start_date && item.play_end_date) {
                  tempArr = [new Date(item.play_start_date), new Date(item.play_end_date)];
                } else {
                  tempArr = [];
                }
                return {
                  ...item,
                  time: tempArr,
                };
              });
            }



            //讲师级别

            if (tea_level_data.length) {
              const obj = {
                'present':(item)=> {  this.vitaForm.tea_present = item;  },
                'previous': (item)=> { this.vitaForm.tea_previous = item; },
                'special': (item)=> { this.vitaForm.tea_special = item;  },
              }
              tea_level_data.forEach((item) => {
                if(item.level) {
                 obj[item.level_type](item)
                 }else{
                    this.vitaForm.tea_present.level=studentSingnInfo.teacher_level;
                    switch(this.vitaForm.tea_present.level){
                      case '0' : this.vitaForm.tea_previous.level = 'A';break
                      case 'A' : this.vitaForm.tea_previous.level = 'B';break
                      case 'B' : this.vitaForm.tea_previous.level = 'C';break
                      case 'C' : this.vitaForm.tea_previous.level = 'D';break
                      case 'D' : this.vitaForm.tea_previous.level = 'E';break
                      case 'E' : this.vitaForm.tea_previous.level = '';break
                    }
                 }

              });
            }else{
              this.vitaForm.tea_present.level=studentSingnInfo.teacher_level;
              switch(this.vitaForm.tea_present.level){
                  case '0' : this.vitaForm.tea_previous.level = 'A';break
                      case 'A' : this.vitaForm.tea_previous.level = 'B';break
                      case 'B' : this.vitaForm.tea_previous.level = 'C';break
                      case 'C' : this.vitaForm.tea_previous.level = 'D';break
                      case 'D' : this.vitaForm.tea_previous.level = 'E';break
                      case 'E' : this.vitaForm.tea_previous.level = '';break
            }
          }
            // console.log(this.vitaForm.tea_present)


            let mixinObj = {
              academic_qualification,
              // coaching_qualification,
              coaching_Experience,
              playing_experience,
              // coa_level_list,
              // honor_experience
              // tea_present,
              // tea_previous,
              // tea_special
            };
            let {entries} = Object;
            for (let [key, value] of entries(mixinObj)) {
              if (value.length === 0) {
                delete mixinObj[key];
              }
            }


            // 学员信息
            // const birthDay = studentSingnInfo.id_number.length == 18
            //   ? studentSingnInfo.id_number.substr(6, 4) + "-" + studentSingnInfo.id_number.substr(10, 2) + "-" + studentSingnInfo.id_number.substr(12, 2)
            //   : "--";
            const birthday = studentSingnInfo.birthday
            if(!birthday){this.canChangeBirthday=true}
            this.noEdit = {
              gender: studentSingnInfo.gender,
              phone: studentSingnInfo.mobile_phone,
              idNum: studentSingnInfo.id_number,
            };
            this.vitaForm = {
              birthday,
              ...this.vitaForm,
              ...studentSingnInfo,
              ...mixinObj,
            };
            this.isLoading = false;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
  }
}
